import React from 'react'
import Helmet from 'react-helmet'

const description = "Front End Center is a screencast series covering the full breadth of topics relevant to front-end web development — from browser features to  clean JavaScript, from performance considerations to understanding modern tools, and everything in between."

export default ({ title, image, url }) => (
  <Helmet title={title}
          meta={[
            { property: "og:title", content: title },
            { property: "og:image", content: image },
            { name: "description", content: description },
            { property: "og:description", content: description },
            { property: "og:url", content: url },
          ]}
  />
)



/** WEBPACK FOOTER **
 ** ./src/components/Head.js
 **/